import { render, staticRenderFns } from "./valuationFeedback.vue?vue&type=template&id=2229322c&scoped=true"
import script from "./valuationFeedback.vue?vue&type=script&lang=js"
export * from "./valuationFeedback.vue?vue&type=script&lang=js"
import style0 from "./valuationFeedback.vue?vue&type=style&index=0&id=2229322c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2229322c",
  null
  
)

export default component.exports